<div class="municipality-container">
    <div><label class="labelTitle" for="municipality">1. {{ 'PREVIEW_SPACE.PROVINCE_SELECT' | translate }}</label></div>
    <div><app-cpm [comunidad]=true [provincia]=true [municipio]=true></app-cpm></div>
</div>